<span class="assignee-name" *ngIf="!isUnknown && fullName">{{ fullName }}</span>
<span class="deactivated" *ngIf="!isUnknown && isDeactivated">({{ locale.deactivated }})</span>
<span class="deactivated" *ngIf="isUnknown && fullName">({{ fullName }})</span>
